import React from "react";
import { Link } from "react-router-dom";
import "./Product2.css";


const Product2 = ({ products }) => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  return (

    <section className="wpo-product-section section-padding">
      <div className="container">
        <div className="wpo-product-wrap">
          <div className="row">
            {products.length > 0 &&
              products.map((product, pitem) => (
                <div className="col col-lg-3 col-md-6 col-sm-6 col-6" key={pitem}>
                  <Link
                    to={`/regalar/${product.slug}`}
                    onClick={ClickHandler}
                    className="product-link"
                  >
                    <div className="wpo-product-item">
                      <div className="wpo-product-img">
                        {product.sold && (
                          <div className="wpo-product-sold">
                            <span>Regalado</span>
                          </div>
                        )}
                        <img src={`/product/${product.image}`} alt="" />
                        {!product.sold && <ul>
                          <li>
                            <button
                              data-bs-toggle="tooltip"
                              data-bs-html="true"
                              title="Regalar ahora"
                              style={{
                                pointerEvents: 'none'
                              }}
                            >
                              Regalar 🎁
                            </button>
                          </li>
                        </ul>}
                      </div>
                      <div className="wpo-product-text">
                        <ul>
                          <li>${product.price}</li>
                        </ul>
                        <h3>{product.title}</h3>
                      </div>
                    </div>
                  </Link>
                </div>
              ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Product2;
